import {SVG} from "@svgdotjs/svg.js";
import {isNan} from "../helpers";


export function renderArena(drawingOptions, disabledSectorsWithoutPopup, customVipSectors) {
    let drawingItemsArray = [];

    const draw = SVG().addTo(`#${drawingOptions.id}`);

    draw.viewbox(0, 0, drawingOptions.width, drawingOptions.height);

    const image = draw.image(drawingOptions.image);
    image.size('100%', '100%').move(0, 0);

    image.id('drawingImg');

    renderSectors(drawingOptions.sectors);

    return drawingItemsArray;

    function renderSectors(sectors) {
        for (let i = 0; i < sectors.length; i++) {

            const sector = sectors[i];
            if (!sector.id) continue;

            addItemSVG(sector, i);
        }


        function addItemSVG(sector = {}, i) {
            const {
                id = null,
                name = '',
                color = '',
                coordinates = '',
                textX = 0,
                textY = 0,
                textRotate = '',
                textColor = ''
            } = sector;

            //для статических секторов и отключенных (пример - Пресса) номер сектора отрисовываем без uppercase
            const isTransformNeed = !isNan(+id) ? 'text-transform: uppercase;' : '';
            drawingItemsArray[i] = draw.path(coordinates);
            let text;

            if(customVipSectors.includes(id)){
                text = draw.text('VIP ' + name.slice(1));

            }else{
                text = draw.text(name);
            }


            //задаём данные для номера сектора
            let fontSize = 10;

            if(drawingOptions.isMetallArena){
                fontSize = 14;

                if(['VIP-A','VIP-B','VIP-C1','VIP-C2','VIP-C3','VIP-C4','VIP-D'].includes(name)){
                    fontSize = 10;
                }
            }

            if(disabledSectorsWithoutPopup.includes(id)){
                fontSize = 0;
            }

            text.font({
                family: 'Golos',
                size: fontSize,
                anchor: 'middle'
            });

            text.attr({
                'x':`${textX}`,
                'y':`${textY}`,
                'data-id': id,
                'data-color': `${textColor}`,
                'fill': `${textColor}`,
                'style':`${isTransformNeed}
                         font-weight:600;
                         pointer-events:none;`,
                'transform':`rotate(${textRotate} ${textX} ${textY})`
            });

            if (id === null || id === 0) {
                drawingItemsArray[i].fill(drawingOptions.colorDisabled);
                drawingItemsArray[i].stroke(drawingOptions.stroke);
                text.attr({'fill': 'white'});

            } else {
                drawingItemsArray[i].fill(color);
            }

            drawingItemsArray[i].style('position', 'relative');
            drawingItemsArray[i].data({
                id,
                name,
                color
            })
        }
    }
}
